import React from "react";
import { motion } from "framer-motion";

const StatTile = ({ label, value, sublabel = null, tone = "default", testid, Icon }) => {
  const toneClass =
    tone === "danger" ? "text-danger"
    : tone === "warning" ? "text-warning"
    : tone === "success" ? "text-success"
    : "text-white";
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="rounded-[12px] bg-bg-secondary border border-border-default p-5"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <div className="jea-caption">{label}</div>
        {Icon ? <Icon size={16} className="text-text-muted" /> : null}
      </div>
      <div className={`mt-2 jea-mono font-extrabold text-[28px] ${toneClass}`}>{value}</div>
      {sublabel && <div className="text-text-muted text-[11px] mt-1">{sublabel}</div>}
    </motion.div>
  );
};

export default StatTile;
